export default __webpack_public_path__ + "static/media/new-more-icon.bb0bb97e.svg";